module.exports = __webpack_public_path__ + "static/media/image016.ef3518d8.jpg";